import client from './client';
import { AuthResponse, User, InviteRequest } from '../types';

export const authApi = {
  login: (email: string, password: string) =>
    client.post<AuthResponse>('/auth/login', { email, password }),

  clerkSync: (token: string) =>
    client.post<AuthResponse>('/auth/clerk', { token }),

  register: (data: {
    token: string;
    first_name: string;
    last_name: string;
    email: string;
    password: string;
  }) => client.post<AuthResponse>('/auth/register', data),

  getMe: () => client.get<{ user: User }>('/auth/me'),

  invite: (data: InviteRequest) =>
    client.post('/auth/invite', data),

  forgotPassword: (email: string) =>
    client.post('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    client.post('/auth/reset-password', { token, password }),
};
